export type Country = { name: string; code: string };

export interface Coordinates {
  latitude: number;
  longitude: number;
}

export enum GeolocationStatusEnum {
  Idle = 'idle',
  PermissionDenied = 'permission-denied',
  ResolvingLocation = 'resolving-location',
  ResolvingCountry = 'resolving-country',
  Success = 'success',
  Error = 'error',
  Unsupported = 'unsupported',
}
